module.exports = __webpack_public_path__ + "assets/img/course-continue-button-arrow.svg";